import type { Dict } from "./pl.js";

export const ko: Dict = {
  navCats: "서비스 분야",
  navHow: "이용 방법",
  navOps: "사업자용",
  navPrice: "요금",
  navContact: "문의",
  navBook: "사업자 패널 데모",
  pill: "서비스 사업자를 위한 예약 플랫폼",
  title1: "당신의 서비스가",
  title2: "스스로 예약됩니다.",
  sub: "b00k는 객실, 차량, 진료 등 모든 서비스 일정을 하나의 예약 시스템으로 모읍니다. 고객은 웹과 채팅으로 직접 예약하고, 시스템이 시간대를 지키며 중복을 막습니다.",
  ctaBook: "사업자 계정 만들기",
  ctaOperator: "고객 화면 보기",
  heroMeta: "YOUR-COMPANY.B00K.ONLINE · 사업자마다 전용 서브도메인",
  cardChip: "확정됨",
  cardNote: "예약은 웹과 채팅에서 저절로 들어와 곧바로 일정을 잠급니다.",
  catsKick: "서비스 분야",
  catsTitle: "b00k로 운영할 수 있는 것",
  catsSub: "모든 서비스를 하나의 플랫폼에서. 시간제 서비스는 차례로 이어지고, 객실과 차량은 날짜 단위로 동시에 예약됩니다.",
  cat1t: "객실",
  cat1d: "1박 또는 여러 박을 위한 객실과 아파트. 같은 날짜에 여러 객실을 동시에 예약할 수 있습니다.",
  cat2t: "차량",
  cat2d: "일 단위 경차와 SUV. 가용 일정표가 인도와 반납을 지킵니다.",
  cat3t: "레저",
  cat3d: "사우나, 스파, 카약. 소요 시간을 정해 특정 시각으로 예약합니다.",
  cat4t: "미용실",
  cat4d: "커트와 염색. 시각만 고르면 시스템이 시술 시간만큼 정확히 잠급니다.",
  cat5t: "에스테틱",
  cat5d: "네일과 마사지. 다른 서비스와 묶으면 소요 시간이 하나의 블록으로 합쳐집니다.",
  cat6t: "의료",
  cat6d: "시각을 정한 진료와 검사. 진료 일정표가 저절로 정리됩니다.",
  cat7t: "정비·수리",
  cat7d: "자동차, 자전거, 노트북까지 모두 다룹니다.",
  cat8t: "개인 교습",
  cat8d: "어학 수업이든 피아노 레슨이든, 저희 플랫폼에서 운영하세요.",
  cat9t: "기타",
  cat9d: "당신 업종의 특성 + 저희의 경험 = 성과.",
  howKick: "이용 방법",
  howTitle: "세 단계, 전화는 필요 없습니다",
  s1t: "서비스와 자원 등록",
  s1d: "객실, 차량, 예약 항목을 소요 시간과 가격과 함께 등록하세요. 가입 시 모든 계정을 검증합니다 — 당신의 계정도, 고객의 계정도.",
  s2t: "고객이 직접 예약",
  s2d: "웹이나 채팅(WhatsApp·Messenger)으로. 소요 시간은 합산되고 객실은 동시에 잡히며, 정말로 비어 있는 시간대만 보입니다.",
  s3t: "시스템이 일정을 지킵니다",
  s3d: "확정되는 순간 시간대가 잠깁니다 — 같은 서비스의 같은 시각을 두 사람이 예약할 수 없습니다. 취소와 변경도 처리됩니다.",
  newChip: "신규",
  chatLine: "고객은 채팅하면서 바로 예약할 수 있습니다 — WhatsApp 또는 Messenger로.",
  opsKick: "사업자용",
  opsTitle: "일정이 당신을 위해 일합니다",
  opsSub: "객실, 차량, 예약을 하나의 일정표에. 중복은 자동으로 막히고 채팅 예약은 저절로 들어오며, 가동률과 매출을 실시간으로 봅니다.",
  opsCta: "사업자 패널 보기",
  f1: "당일 일정표와 자원 가동 현황을 한 화면에",
  f2: "예약 충돌 자동 차단",
  f3: "웹과 채팅에서 오는 예약 — WhatsApp / Messenger",
  f4: "고객, 예약 메모, 핵심 지표",
  priceKick: "요금",
  priceTitle: "예약만큼 간단하게",
  month: "월",
  recommended: "추천",
  soon: "곧 제공",
  custom: "개별 견적",
  opsSuffix: "명 직원",
  priceNote: "월 요금은 패널에 접근하는 직원 수에 따라 정해집니다.",
  t1f1: "일정표와 웹 예약",
  t1f2: "WhatsApp / Messenger 채팅",
  t1f3: "고객, 메모, 알림",
  t2f1: "SOLO의 모든 기능",
  t2f2: "자원과 서비스 수 제한 없음",
  t2f3: "보고서와 가동률 지표",
  t3f1: "TEAM의 모든 기능",
  t3f2: "직원 근무표와 역할",
  t3f3: "API와 연동",
  t4f1: "GROUP의 모든 기능",
  t4f2: "도입 지원과 SLA",
  t4f3: "개별 계약과 정산",
  conKick: "문의 및 오시는 길",
  conTitle: "당신의 위치, 고객의 경로",
  dirKick: "오시는 길 — 고객에게 보이는 그대로",
  dir1: "자동차: 옐레니아구라에서 3번 국도, 슈클라르스카포렌바 중심가 출구로 나와 즈드로요바 거리로 5분.",
  dir2: "기차: 슈클라르스카포렌바구르나 역에서 중심가 방향으로 도보 12분.",
  dir3: "부지 내 방문객 주차장 — 무료, 예약 불필요.",
  footUser: "고객 화면",
  footOp: "사업자 패널",

  wizTitle: "사업자 계정 만들기",
  wizSub: "일곱 단계. 마치면 전용 서브도메인과 바로 쓸 수 있는 패널이 생깁니다.",
  wizStep1: "회사",
  wizStep2: "서브도메인",
  wizStep3: "업종",
  wizStep4: "요금제",
  wizStep5: "관리자",
  wizStep6: "결제",
  wizStep7: "확인",
  wizNext: "다음",
  wizBack: "이전",
  wizFinish: "계정 만들기",
  fCompany: "회사명",
  fNip: "사업자번호(NIP)",
  fPhone: "전화번호",
  fAddress: "주소",
  fSlug: "서브도메인",
  slugHint: "고객이 이 주소에서 당신의 서비스를 예약합니다.",
  slugChecking: "사용 가능 여부를 확인하는 중…",
  slugFree: "사용할 수 있는 서브도메인입니다.",
  slugTaken: "이미 사용 중인 서브도메인입니다.",
  slugInvalid: "서브도메인: 3~63자, 소문자·숫자·하이픈(맨 앞과 맨 뒤에는 불가).",
  industriesHint: "취급하는 업종을 고르세요. 나중에 패널에서 추가할 수 있습니다.",
  planHint: "요금제는 언제든 바꿀 수 있습니다 — 데이터는 그대로입니다.",
  fName: "이름",
  fEmail: "이메일",
  fPass: "비밀번호(8자 이상)",
  fPass2: "비밀번호 재입력",
  fTerms: "b00k.online 이용약관에 동의하며, 예약 처리를 위한 데이터 처리에 동의합니다.",
  payTitle: "고객 결제",
  payHint: "선택 사항입니다. 예약 확정 시 온라인 결제를 받을 수 있습니다.",
  payEnable: "온라인 결제 받기",
  payMethods: "결제 수단",
  sumTitle: "확인",
  sumCompany: "회사",
  sumSub: "서브도메인",
  sumIndustries: "업종",
  sumPlan: "요금제",
  sumAdmin: "관리자",
  sumPayments: "결제",
  yes: "예",
  no: "아니오",
  doneTitle: "사업자 계정이 준비되었습니다",
  doneSub: "서브도메인이 열렸습니다. 패널에 로그인해 서비스를 추가하면 예약이 바로 시작됩니다.",
  doneOpen: "사업자 패널 열기",
  doneBooking: "예약 페이지 보기",
  companyProofOk: "회사 관리자로 로그인했습니다:",
  companyLoginOther: "다른 계정으로 로그인",
  errGeneric: "계정을 만들지 못했습니다. 입력한 내용을 확인하고 다시 시도해 주세요.",
};
